import { render } from "./search-drawer.vue?vue&type=template&id=0f6de5d5"
import script from "./search-drawer.vue?vue&type=script&lang=js"
export * from "./search-drawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__